import React from "react"
import "./BSReplace.css"

type ColSize = number | "auto" | undefined | null | boolean

export interface ColProps extends React.HTMLAttributes<HTMLDivElement> {
	as?: React.ElementType
	htmlFor?: string
	xs?: ColSize
	sm?: ColSize
	md?: ColSize
	lg?: ColSize
	xl?: ColSize
}

const buildColClasses = (props: ColProps): string => {
	const classes: string[] = ["col"]

	// Handle xs (default size)
	if (props.xs !== undefined && props.xs !== null) {
		if (props.xs === "auto") {
			classes[0] = "col-auto"
		} else if (typeof props.xs === "number") {
			classes[0] = `col-${props.xs}`
		}
	}

	// Handle responsive breakpoints
	const breakpoints = ["sm", "md", "lg", "xl"] as const
	breakpoints.forEach((breakpoint) => {
		const value = props[breakpoint]
		if (value === true) {
			classes.push(`col-${breakpoint}`)
		}
		if (value !== undefined && value !== null && value !== false) {
			if (value === "auto") {
				classes.push(`col-${breakpoint}-auto`)
			} else if (typeof value === "number") {
				classes.push(`col-${breakpoint}-${value}`)
			}
		}
	})

	return classes.join(" ")
}

export const Col = React.forwardRef<HTMLDivElement, ColProps>(
	({ as, htmlFor, xs, sm, md, lg, xl, className, ...props }, ref) => {
		const colClasses = buildColClasses({ xs, sm, md, lg, xl })
		const finalClassName = `${colClasses}${className ? ` ${className}` : ""}`
		const Component = as ?? ("div" as React.ElementType)

		return <Component ref={ref} className={finalClassName} htmlFor={htmlFor} {...props} />
	}
)

export default Col
